export const auctionStatuses = Object.freeze({
  CURRENT: 'current',
  SOLD: 'sold',
  NOT_SOLD: 'not_sold',
  WAITING: 'waiting',
  DISABLED: 'disabled',
})

export const auctionStatusTranslation = (status, t) => {
  switch (status) {
    case auctionStatuses.CURRENT:
    case auctionStatuses.SOLD:
    case auctionStatuses.WAITING:
      return t(status)
    case auctionStatuses.NOT_SOLD:
      return t('notSold')
    default:
      return ''
  }
}
